import axios from "axios";
import { useEffect, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";


const ExecutiveRegistration = () => {
  const [FirstName, setFirstName] = useState('')
  const [MiddleName, setMiddleName] = useState('')
  const [LastName, setLastName] = useState('')
  const [Dob, setDob] = useState('')
  const [State, setState] = useState('')
  const [District, setDistrict] = useState('')
  const [City, setCity] = useState('')
  const [Area, setArea] = useState('')
  const [Pincode, setPincode] = useState('')
  const [Pancard, setPancard] = useState(null)
  const [Aadhaar, setAadhaar] = useState(null)
  const [BankName, setBankName] = useState('')
  const [BranchName, setBranchName] = useState('')
  const [AccountHolderName, setAccountHolderName] = useState('')
  const [AccountNumber, setAccountNumber] = useState('')
  const [IFSCCode, setIFSCCode] = useState('')
  const [Password, setPassword] = useState('')
  const [ConfirmPassword, setConfirmPassword] = useState('')
  const [Username, setUsername] = useState('')
  const [Email, setEmail] = useState('')
  const [mobile, setMobile] = useState('')
  const [alternateMobile, setAlternateMobile] = useState('')
  const [aadhaarNumber, setAadhaarNumber] = useState('')
  const [panNumber, setPanNumber] = useState('')

  const [eyePassword, setEyePassword] = useState(false)
  const [confirmeyePassword, setConfirmEyePassword] = useState(false)

  const [showEyePassword, setShowEyePassword] = useState(false)
  const [confirmshowEyePassword, setConfirmShowEyePassword] = useState(false);

  const [allStates,setAllStates] = useState([])
  const [allDistricts,setAllDistricts] = useState([])

  const { executiveCode } = useParams();
  const navigate = useNavigate()

  const [formError, setFormError] = useState("");
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).{8,}$/;
  const mobileRegex = /^[6-9]\d{9}$/;


  const validate = () => {
    let error = "";

    if (!FirstName) error = "First name is required";
    else if (!LastName) error = "Last name is required";
    else if (!Dob) error = "Date of birth is required";
    else if (!State) error = "State is required";
    else if (!District) error = "District is required";
    else if (!City) error = "City is required";
    else if (!Area) error = "Area is required";
    else if (!Pincode || Pincode.length !== 6)
      error = "Pincode must be 6 digits";
    else if (!Email) error = "Email is required";
    else if (!emailRegex.test(Email)) error = "Invalid email format";
    else if (!Username || Username.length < 4)
      error = "Username must be at least 4 characters";
    else if (!Aadhaar) error = "Please upload Aadhaar";
    else if (!Pancard) error = "Please upload Pancard";
    else if (!BankName) error = "Bank name is required";
    else if (!BranchName) error = "Branch name is required";
    else if (!AccountHolderName)
      error = "Account holder name is required";
    else if (!AccountNumber || AccountNumber.length < 9)
      error = "Invalid account number";
    else if (!IFSCCode || !ifscRegex.test(IFSCCode))
      error = "Invalid IFSC code";
    else if (!Password) error = "Password is required";
    else if (!passwordRegex.test(Password))
      error =
        "Password must be 8 chars with uppercase, lowercase, number & special character";
    else if (Password !== ConfirmPassword)
      error = "Password and Confirm Password do not match";
    else if (!mobile)
      error = "Mobile number is required";
    else if (!mobileRegex.test(mobile))
      error = "Mobile number must be 10 digits and start with 6-9";

    else if (!alternateMobile)
      error = "Alternate mobile number is required";
    else if (!mobileRegex.test(alternateMobile))
      error = "Alternate mobile number must be 10 digits and start with 6-9";
    else if (mobile === alternateMobile)
      error = "Mobile and Alternate Mobile numbers cannot be the same";


    setFormError(error);
    return error === "";
  };

  const handelForm = (e) => {
    e.preventDefault();
    if (!validate()) return;



    const formData = new FormData();

    formData.append("FirstName", FirstName);
    formData.append("MiddleName", MiddleName);
    formData.append("LastName", LastName);
    formData.append("Dob", Dob);
    formData.append("MobileNumber", mobile);
    formData.append("AlternateMobileNumber", alternateMobile);
    formData.append("State", State);
    formData.append("District", District);
    formData.append("City", City);
    formData.append("Area", Area);
    formData.append("Pincode", Pincode);
    formData.append("Address", State + ',' + District + ',' + City + ',' + Area + "," + Pincode);

    // files
    formData.append("AadharCopy", Aadhaar);
    formData.append("AadharNumber", aadhaarNumber);
    formData.append("PANNumber", panNumber);
    formData.append("PanCopy", Pancard);

    formData.append("BankName", BankName);
    formData.append("BranchName", BranchName);
    formData.append("AccountHolderName", AccountHolderName);
    formData.append("AccountNumber", AccountNumber);
    formData.append("IFSCCode", IFSCCode);
    formData.append("RefferedByBDECode", executiveCode);
    formData.append("Username", Username);
    formData.append("Email", Email);
    formData.append("Password", Password);

    if (Password === ConfirmPassword) {
      axios.post('https://api.bakpoket.com/api/BDExecutive/register', formData)
        .then(res => {
          // console.log(res)
          alert('Executive Registration Successfull')
          navigate('/executiveSignin')
        })
        .catch(err => {
          console.log(err)
          alert('Executive Registration  Failed')
        })
    } else {
      alert('Password and ConfirmPassword must be same')
    }
  };

  const clearError = () => setFormError("");

  useEffect(()=>{
    axios.get('https://api.kredasit.com/api/State/allStates')
    .then(res =>{setAllStates(res.data)})
    .catch(err=>console.log(err))
  },[])



  const selectedState=(e)=>{
    console.log(e.target.value)
    const state = e.target.value;
    setState(state)
    axios.get(`https://api.kredasit.com/api/State/districtsByStateName/${state}`)
    .then(res =>{setAllDistricts(res.data)})
    .catch(err=>console.log(err))
  }
  return (
    <Wrapper>
      <div className="container my-3  p-2" >
        <form onSubmit={handelForm}>
          <div className="row p-2 rounded p-sm-3 mx-2" style={{ backgroundColor: 'rgb(233, 231, 231)' }}>
            <h3 className="d-flex justify-content-center mb-sm-3 mb-2">Executive Registration</h3>

            <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
              <label className="ms-1" htmlFor="FirstName">First Name <span style={{ color: 'red' }}>*</span></label>
              <input id="FirstName" type="text" value={FirstName} onChange={(e) => { setFirstName(e.target.value) }} onInput={validate} style={{ padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', }} />
            </div>
            <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
              <label className="ms-1" htmlFor="MiddleName">Middle Name</label>
              <input id="MiddleName" type="text" value={MiddleName} onChange={(e) => setMiddleName(e.target.value)} onInput={validate} style={{ padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', }} />
            </div>
            <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
              <label className="ms-1" htmlFor="LastName">Last Name <span style={{ color: 'red' }}>*</span></label>
              <input id="LastName" type="text" value={LastName} onChange={(e) => setLastName(e.target.value)} onInput={validate} style={{ padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', }} />
            </div>
            <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
              <label className="ms-1" htmlFor="Username">User Name <span style={{ color: 'red' }}>*</span></label>
              <input type="text" id="Username" value={Username} onChange={(e) => setUsername(e.target.value)} onInput={validate} style={{ padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', }} />
            </div>
            <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
              <label className="ms-1" htmlFor="Password">Password <span style={{ color: 'red' }}>*</span></label>
              <span style={{ position: 'relative', width: '100%' }}>
                <input type={showEyePassword ? 'text' : 'password'} id="Password" value={Password} onChange={(e) => setPassword(e.target.value)} onInput={validate} style={{ width: '100%', padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', }} />
                {Password.length > 0 ? (
                  eyePassword ? (<FaEyeSlash style={{ position: 'absolute', right: '10', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }} onClick={() => { setEyePassword(false); setShowEyePassword(false) }} />)
                    : (<FaEye style={{ position: 'absolute', right: '10', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }} onClick={() => { setEyePassword(true); setShowEyePassword(true) }} />)) : (null)
                }
              </span>
            </div>
            <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
              <label className="ms-1" htmlFor="ConfirmPassword">Confirm Password <span style={{ color: 'red' }}>*</span></label>
              <span style={{ position: 'relative', width: '100%' }}>
                <input type={confirmshowEyePassword ? 'text' : 'password'} id="ConfirmPassword" value={ConfirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} onInput={validate} style={{ padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', width: '100%' }} />
                {ConfirmPassword.length > 0 ? (
                  confirmeyePassword ? (<FaEyeSlash style={{ position: 'absolute', right: '10', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }} onClick={() => { setConfirmEyePassword(false); setConfirmShowEyePassword(false) }} />)
                    : (<FaEye style={{ position: 'absolute', right: '10', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }} onClick={() => { setConfirmEyePassword(true); setConfirmShowEyePassword(true) }} />)) : (null)
                }
              </span>
            </div>
            <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
              <label className="ms-1" htmlFor="Dob">Dob <span style={{ color: 'red' }}>*</span></label>
              <input id="Dob" type="date" value={Dob} onChange={(e) => setDob(e.target.value)} onInput={validate} style={{ padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', width: '100%' }} />
            </div>
            <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
              <label className="ms-1" htmlFor="Email">Email <span style={{ color: 'red' }}>*</span></label>
              <input type="email" id="Email" value={Email} onChange={(e) => setEmail(e.target.value)} onInput={validate} style={{ padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', }} />
            </div>
            <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
              <label className="ms-1" htmlFor="mobile">Mobile Number <span style={{ color: 'red' }}>*</span></label>
              <input id="mobile" type="text" value={mobile} onChange={(e) => setMobile(e.target.value)} onInput={validate} style={{ padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', width: '100%' }} />
            </div>
            <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
              <label className="ms-1" htmlFor="alternateMobile">Alternate Mobile Number<span style={{ color: 'red' }}>*</span></label>
              <input id="alternateMobile" type="text" value={alternateMobile} onChange={(e) => setAlternateMobile(e.target.value)} onInput={validate} style={{ padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', width: '100%' }} />
            </div>
            <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
              <label className="ms-1" htmlFor="aadhaarNumber">Aadhaar Number <span style={{ color: 'red' }}>*</span></label>
              <input id="aadhaarNumber" type="text" value={aadhaarNumber} onChange={(e) => setAadhaarNumber(e.target.value)} onInput={validate} style={{ padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', }} />
            </div>
            <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
              <label className="ms-1" htmlFor="Aadhaar">Aadhaar Upload <span style={{ color: 'red' }}>*</span></label>
              <input type="file" accept="image/*" id="Aadhaar" onChange={(e) => setAadhaar(e.target.files[0])} onInput={validate} style={{ padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', backgroundColor: '#fff' }} />
            </div>
            <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
              <label className="ms-1" htmlFor="panNumber">Pan Number <span style={{ color: 'red' }}>*</span></label>
              <input id="panNumber" type="text" value={panNumber} onChange={(e) => setPanNumber(e.target.value)} onInput={validate} style={{ padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', }} />
            </div>
            <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
              <label className="ms-1" htmlFor="Pancard">Pan Upload <span style={{ color: 'red' }}>*</span></label>
              <input type="file" accept="image/*" id="Pancard" onChange={(e) => setPancard(e.target.files[0])} onInput={validate} style={{ padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', backgroundColor: '#fff' }} />
            </div>
            <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
              <label className="ms-1" htmlFor="State">State <span style={{ color: 'red' }}>*</span></label>
               {/* <input id="State" type="text" value={State} onChange={(e) => setState(e.target.value)} onInput={validate} style={{ padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', }} /> */}
              <select style={{ padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', }}  onChange={(e)=>selectedState(e)}>
                <option value={''}>Select State</option>
                {allStates.map((item,index)=>(
            
                  <option key={index} value={item.name}>{item.name}</option>
                ))}
              </select>
            </div>
            <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
              <label className="ms-1" htmlFor="District">District <span style={{ color: 'red' }}>*</span></label>
              {/* <input id="District" type="text" value={District} onChange={(e) => setDistrict(e.target.value)} onInput={validate} style={{ padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', }} /> */}
                <select style={{ padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', }}  onChange={(e) => setDistrict(e.target.value)}>
                <option value={''}>Select District</option>
                {allDistricts.map((item,index)=>(
            
                  <option key={index} value={item.name}>{item.name}</option>
                ))}
              </select>
            </div>
            <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
              <label className="ms-1" htmlFor="City">City <span style={{ color: 'red' }}>*</span></label>
              <input id="City" type="text" value={City} onChange={(e) => setCity(e.target.value)} onInput={validate} style={{ padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', }} />
            </div>
            <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
              <label className="ms-1" htmlFor="Area">Area <span style={{ color: 'red' }}>*</span></label>
              <input id="Area" type="text" value={Area} onChange={(e) => setArea(e.target.value)} onInput={validate} style={{ padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', }} />
            </div>
            <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
              <label className="ms-1" htmlFor="Pincode">Pin Code <span style={{ color: 'red' }}>*</span></label>
              <input id="Pincode" type="number" value={Pincode} onChange={(e) => setPincode(e.target.value)} onInput={validate} style={{ padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', }} />
            </div>
            <h4>Please Provide Your Bank Details</h4>
            <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
              <label className="ms-1" htmlFor="AccountHolderName">Account Holder Name <span style={{ color: 'red' }}>*</span></label>
              <input type="text" id="AccountHolderName" value={AccountHolderName} onChange={(e) => setAccountHolderName(e.target.value)} onInput={validate} style={{ padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', }} />
            </div>
            <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
              <label className="ms-1" htmlFor="BankName">Bank Name <span style={{ color: 'red' }}>*</span></label>
              <input type="text" id="BankName" value={BankName} onChange={(e) => setBankName(e.target.value)} onInput={validate} style={{ padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', }} />
            </div>
            <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
              <label className="ms-1" htmlFor="BranchName">Branch Name <span style={{ color: 'red' }}>*</span></label>
              <input type="text" id="BranchName" value={BranchName} onChange={(e) => setBranchName(e.target.value)} onInput={validate} style={{ padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', }} />
            </div>
            <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
              <label className="ms-1" htmlFor="AccountNumber">Account Number <span style={{ color: 'red' }}>*</span></label>
              <input type="text" id="AccountNumber" value={AccountNumber} onChange={(e) => setAccountNumber(e.target.value)} onInput={validate} style={{ padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', }} />
            </div>
            <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
              <label className="ms-1" htmlFor="IFSCCode">IFSC Code <span style={{ color: 'red' }}>*</span></label>
              <input type="text" id="IFSCCode" value={IFSCCode} onChange={(e) => setIFSCCode(e.target.value)} onInput={validate} style={{ padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', }} />
            </div>
            {/* <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
              <label className="ms-1" htmlFor="ExecutiveCode">Executive Code</label>
              <input type="text" id="ExecutiveCode" value={ExecutiveCode} onChange={(e) => setExecutiveCode(e.target.value)} onInput={validate} style={{ padding: '7px', borderRadius: ' 6px', border: '1px solid #ccc', fontSize: '13px', }} />
            </div> */}




            <div className="agreement d-flex justify-content-center align-items-center mb-2 gap-1">
              <input type="checkbox" required />
              <p className="mb-0" style={{ fontSize: '13px' }}>I agree with the <NavLink to='/executiveTerms-Service' style={{ color: '#ef4766', textDecoration: 'none', fontSize: '13px', fontWeight: '600' }} >Terms & Conditions</NavLink></p>
            </div>
            <div className="d-flex justify-content-center  align-items-center flex-column">
              {formError && <small style={{ fontSize: '12px', color: 'red' }}>{formError}</small>}
              <button type="submit" className="auth-btn">Sign Up</button>
            </div>

            <div className="d-flex justify-content-center">
              <SwitchText>
                Already have an account? <NavLink to='/executiveSignin' style={{ textDecoration: 'none' }}><span>Sign In</span></NavLink>
              </SwitchText>
            </div>
          </div>
        </form>
      </div>
    </Wrapper>
  )
}
export default ExecutiveRegistration;


const SwitchText = styled.p`
  font-size: 13px;
  margin-top: 10px;
  margin-bottom: 0px;

  span {
    color: #ef4766;
    cursor: pointer;
    font-weight: bold;
  }

  @media (max-width: 600px) {
    font-size: 9px;
    margin-top: 2px;
    margin-bottom: 2px;
  }
`;

const Wrapper = styled.section`
    .auth-btn {
    background-color: #ef4766;
    color: white;
    border: none;
    padding: 10px;
    border-radius: 6px;
    font-weight: bold;
    width: 100%;
    font-size: 16px;
    cursor: pointer;
    transition: background 0.3s ease;
    max-width:250px;

    &:hover {
      background-color: #d91212;
    }
  }
`

